import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-case-update-detail-overview',
  templateUrl: './case-update-detail-overview.component.html',
  styleUrls: ['./case-update-detail-overview.component.css']
})
export class CaseUpdateDetailOverviewComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
